var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalliCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62 11.1494C8.06 13.9794 10.38 16.2994 13.21 17.7394L15.41 15.5394C15.69 15.2594 16.08 15.1794 16.43 15.2894C17.55 15.6594 18.75 15.8594 20 15.8594C20.2652 15.8594 20.5196 15.9647 20.7071 16.1523C20.8946 16.3398 21 16.5942 21 16.8594V20.3594C21 20.6246 20.8946 20.8789 20.7071 21.0665C20.5196 21.254 20.2652 21.3594 20 21.3594C15.4913 21.3594 11.1673 19.5683 7.97918 16.3802C4.79107 13.1921 3 8.86806 3 4.35938C3 4.09416 3.10536 3.8398 3.29289 3.65227C3.48043 3.46473 3.73478 3.35938 4 3.35938H7.5C7.76522 3.35938 8.01957 3.46473 8.20711 3.65227C8.39464 3.8398 8.5 4.09416 8.5 4.35938C8.5 5.60938 8.7 6.80938 9.07 7.92938C9.18 8.27938 9.1 8.66937 8.82 8.94938L6.62 11.1494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalliCon);
export default __webpack_public_path__ + "static/media/calliCon.984267f251252b538b195503f4cf06b2.svg";
export { ForwardRef as ReactComponent };